import React from 'react';
import { Permission } from 'Generated/schema';
import useCheckPermissions from 'Hooks/useCheckPermissions';

export interface RoleRestrictedAccessProps {
  allowedPermissions: Permission[];
  logic?: 'OR' | 'AND';
  fallback?: React.ReactElement | null;
  children: React.ReactNode; // we need to specify it due to React.memo(..) down below
}

const RoleRestrictedAccess: React.FC<RoleRestrictedAccessProps> = ({
  allowedPermissions,
  logic,
  fallback = null,
  children,
}) => {
  const isAllowedToProceed = useCheckPermissions(allowedPermissions, logic);

  if (!isAllowedToProceed) {
    return fallback;
  }

  return children as React.ReactElement;
};

export default React.memo(RoleRestrictedAccess);
